import React, { useState } from 'react';

import './css/stylesheet.css';
import './fonts/fontsheet.css';
const Draggable = require('react-draggable');
const DraggableCore = Draggable.DraggableCore;

function CloseButton({ setWindows }){
    return (
        <button style={{margin: "0.25em"}} onClick={setWindows}>X</button>
    );
}

function ExpandButton({ setExpanded }){
    return (
        <button style={{margin: "0.25em"}} onClick={setExpanded}>O</button>
    );
}

function WindowHeader({ windowName, setWindows, setExpanded }){
    return(
        <div className="header" style={{
            textAlign: "center",
            borderBottom: "1px solid #000000",
            display: "flex",
            justifyContent: "space-between"
        }}>
            <CloseButton setWindows={setWindows}/>
            <h1 style={{
                display: "inline",
                fontSize: "1em",
                paddingTop: "0.1em",
                paddingBottom: "0.1em",
                margin: 0
            }}><span>{ windowName }</span></h1>
            <ExpandButton setExpanded={setExpanded}/>
        </div>
    );
}

function Window({ children, windowName, setWindows }){
    const [expanded, setExpanded] = useState(false);

    const renderChildren = () => {
      return React.Children.map(children, (child) => {
        return React.cloneElement(child, {expanded});
      });
    };

    return (
        <Draggable 
            handle=".header" 
            bounds="parent" 
            positionOffset={{ x: '0%', y: '1.5em' }} 
        >
            <article style={{
                border: "2px solid #000000",
                backgroundColor: "#EFEFEF",
                maxWidth: expanded ? "98%" : 500,
                height: expanded? "98%": "auto"
            }}>
                <WindowHeader windowName={windowName} setWindows={setWindows} setExpanded={()=> setExpanded(!expanded)}/>
                <div style={{height: expanded ? "91vh": 400}}>
                    { renderChildren() }
                </div>
            </article>
        </Draggable>
    );
}

export default Window;